import { useEffect } from "react";
import type { View } from "./hashRoute.js";

// Browser tab titles follow ui-ux-standard rule 13: most specific segment first, site name last,
// joined by " | ". Titles are section names only - never the household name, a log entry, or
// anything else from the user's personal logs, because titles persist in browser history, sync
// and screen shares.

export const SITE_NAME = "Life Logger";
const SEPARATOR = " | ";

// Tab title per view. A Record over View, so adding a view to VIEWS without a title here is a
// compile error.
export const VIEW_TITLES: Record<View, string> = {
  dashboard: "Dashboard",
  logs: "Logs",
  chat: "Chat",
  reports: "Reports",
  spend: "Spend",
  settings: "Settings",
};

/** Joins segments most-specific-first and appends the site name. Blank segments are dropped. */
export function formatPageTitle(...segments: Array<string | null | undefined>): string {
  const parts = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));
  return [...parts, SITE_NAME].join(SEPARATOR);
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
